import React, { createContext } from 'react';
import moment from 'moment';
import { TIME_FORMAT } from '@ubeya/shared/constants';

export const contextDefaultValues = {
  hourFormat: 24,
  timeFormat: TIME_FORMAT[24],
  dateFormat: 'DD/MM/YYYY',
  shortDateFormat: 'DD/MM/YY',
  shortDateMonthFormat: 'DD/MM',
  firstDayOfWeek: 1,
  currency: '$',
  countryCode: 'US',
  distanceUnit: 'km',
  distanceUnitShortTranslationKey: 'distanceUnit_km_short',
  disableEmployeeIdField: false,
  disableClientAddFromEvent: false,
  enableClientCostCenterFeature: false,
  enableContractFeature: false,
  enableContractLeaveManagementFeature: false,
  enableLiveView: false,
  isAccountNetworkAccessSupplier: false
};

const ConfigContext = createContext({
  hourFormat: 24,
  timeFormat: TIME_FORMAT[24],
  dateFormat: 'DD/MM/YYYY',
  shortDateFormat: 'DD/MM/YY',
  shortDateMonthFormat: 'DD/MM',
  firstDayOfWeek: 1,
  currency: '$',
  countryCode: 'US',
  distanceUnit: 'km',
  distanceUnitShortTranslationKey: 'distanceUnit_km_short',
  disableEmployeeIdField: false,
  disableClientAddFromEvent: false,
  enableClientCostCenterFeature: false,
  enableContractFeature: false,
  enableContractLeaveManagementFeature: false,
  isEngagementAccount: false,
  enableLiveView: false,
  isAccountNetworkAccessSupplier: false
});

export default ConfigContext;

export const ConfigContextProvider = ({ config, children }) => {
  moment.updateLocale('en', { week: { dow: config.firstDayOfWeek - 1 } });

  return <ConfigContext.Provider value={config}>{children}</ConfigContext.Provider>;
};
